import axios, {AxiosResponse} from 'axios';

const get = (): Promise<AxiosResponse> => {
  const baseUrl = 'https://fo-prod-stats-banner.s3-eu-west-1.amazonaws.com/funding-stats.json';
  return axios.get(baseUrl);
};

const BusinessStats = {
  get,
};

export default BusinessStats;
